module.exports = __webpack_public_path__ + "static/img-set-light-31754917cdaec3c37c53902f8795a6f8.jpg";